import { isMock } from '../config'
import { checkinMock } from './mock'
import { checkinReal } from './real'
import type { CheckinService } from './types'

export const checkinService: CheckinService = isMock('checkin') ? checkinMock : checkinReal
export { EMPTY_GUEST, fieldError, fieldRules, stepErrors, spainId, ageOn, ageRequirements, IDENTIFIER_TYPE } from './rules'
export type { FieldError } from './rules'
export type {
  Arrival,
  ArrivalInput,
  ArrivalOptions,
  ArrivalSlot,
  CheckinService,
  ContractSummary,
  EarlyCheckin,
  FieldRules,
  GuestAttachments,
  GuestData,
  GuestField,
  GuestRelationshipInput,
  Occupant,
  OccupantState,
  SavedGuest,
  Transport,
} from './types'
